import React, { FC } from 'react';
import { Image } from '@src/components/Image';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import { MetricContext } from '@src/metrics/metrics.enum';
import { Button } from '@src/components/Button';
import { NEW_FUNNEL_ROUTE } from '@src/Routes/links';
import { trackViewCreateTargeting } from '@src/metrics';
import './styles.scss';

export const EmptyState: FC = () => {
  return (
    <div className="empty-state">
      <Image
        alt=""
        className="empty-state__image"
        src={`${STATIC_MEDIA_DOMAIN}/images/activity-feed-empty-state.png`}
      />
      <div className="empty-state__info">
        <h4>Post a job to get started</h4>
        <p>Create a job opening to track views in real-time.</p>
        <Button
          className="empty-state__post-opening"
          isLink
          onClick={() =>
            trackViewCreateTargeting({
              'Previous Context': MetricContext.SOURCE,
            })
          }
          to={NEW_FUNNEL_ROUTE}
        >
          Post a job opening
        </Button>
      </div>
    </div>
  );
};
